import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from '../../../hooks';
import { selectNexaTransmitter } from '../../../reducers/nexaTransmittersSlice';
import { nexaTransmitterKindLabel } from '../../../types/NexaTransmitter';
export const ConfigNexaTransmitterRow = (props) => {
    const transmitter = useAppSelector(selectNexaTransmitter(props.id));
    if (!transmitter) {
        return null;
    }
    const active = true;
    const label_classes = 'inactive label ' + (active ? ' hidden' : '');
    return (_jsxs("div", { className: "config-transmitter-row", children: [_jsxs("div", { children: [transmitter.title, _jsx("span", { className: label_classes, children: "Inaktiv" })] }), _jsx("div", { children: nexaTransmitterKindLabel(transmitter.kind) }), _jsx("div", { className: "pull-right", children: _jsx("button", { className: "edit lw small", onClick: () => props.editHandler(transmitter.id), children: "\u00A0Redigera\u00A0" }) })] }));
};
